import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EmperorCardHeaderColor, EmperorDialogConfig, EmperorDialogRef, EmperorUIButtonTypes } from '@boldpenguin/emperor-presentational';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EmperorUIQuestion } from '../../models';

@UntilDestroy()
@Component({
  selector: 'emperor-searchable-list-dialog',
  templateUrl: './searchable-list-dialog.component.html',
  styleUrls: ['./searchable-list-dialog.component.scss'],
})
export class SearchableListDialogComponent implements OnInit {
  readonly colorPrimary = EmperorCardHeaderColor.PRIMARY;
  readonly textButton = EmperorUIButtonTypes.Text;
  searchableListQuestionControl: FormControl;
  searchableListQuestion: EmperorUIQuestion;
  headerText: string;
  dialogWidth: string | undefined;
  dialogHeight: string | undefined;

  constructor(config: EmperorDialogConfig, private dialogRef: EmperorDialogRef) {
    this.searchableListQuestionControl = config.data.searchableListQuestionControl;
    this.searchableListQuestion = config.data.searchableListQuestion;
    this.headerText = config.data.headerText;
    this.dialogHeight = config.data.dialogHeight;
    this.dialogWidth = config.data.dialogWidth;
  }

  ngOnInit(): void {
    this.searchableListQuestionControl.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe(value => (this.searchableListQuestion.value = value));
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.dialogRef.close(this.searchableListQuestionControl.value);
  }
}
